// extracted by mini-css-extract-plugin
export default {"container":"UserInfo_container__1inAy"};